// extracted by mini-css-extract-plugin
export default {"restoreLink":"ProjectItemSectionFieldList-module__restoreLink--npi95"};